import { render, staticRenderFns } from "./LoanItem.vue?vue&type=template&id=2a4c94a6&"
import script from "./LoanItem.vue?vue&type=script&lang=js&"
export * from "./LoanItem.vue?vue&type=script&lang=js&"
import style0 from "./LoanItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports